import { useRoutes } from "react-router-dom";
import { ROLES } from "../constants";
import { useTypedSelector } from "../hooks/useTypedSelector";
import Collections from "../scenes/collections";
import NftDetails from "../scenes/nftDetails";
import Overview from "../scenes/overview";
import Profile from "../scenes/profile";
import ScholarDetails from "../scenes/scholarDetails";
import ScholarDetailsProfile from "../scenes/ScholarDetailsProfile";
import ScholarProfile from "../scenes/ScholarProfile";
import Tokens from "../scenes/Tokens";

export const Routes = () => {
  const { connectedAccount } = useTypedSelector((state) => state.apiReducer);
  const guildRoutes = [
    {
      path: "/",

      children: [
        // {
        //   path: "/",
        //   element: <Overview />,
        // },
        {
          path: "/",
          element: <Collections />,
        },
        {
          path: "/collections/:address",
          element: <Profile />,
        },
        {
          path: "/collections/:address/:tokenId",
          element: <NftDetails />,
        },
        {
          path: "/scholar-details",
          element: <ScholarDetails />,
        },
        {
          path: "/scholar-details/:scholarId",
          element: <ScholarDetailsProfile />,
        },
        {
          path: "/tokens",
          element: <Tokens />,
        },
      ],
    },
  ];

  const scholarRoutes = [
    {
      path: "/",

      children: [
        // {
        //   path: "/",
        //   element: <Overview />,
        // },
        {
          path: "/",
          element: <ScholarProfile />,
        },
        // {
        //   path: "/collections/:address",
        //   element: <ScholarProfile />,
        // },
        {
          path: "/collections/:address/:tokenId",
          element: <NftDetails />,
        },
        {
          path: "/tokens",
          element: <Tokens />,
        },
      ],
    },
  ];
  return useRoutes(
    connectedAccount.role === ROLES.GUILD ? guildRoutes : scholarRoutes
  );
};
